(function () {
  // URLパラメータをチェックして、homepageクラスを追加
  const checkViewParam = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const view = urlParams.get('view');

    if (view === 'aseave-about' || view === 'ashitaba-contact' || view === 'olive-contact') {
      const sections = document.querySelectorAll('.aseave-ritual');
      sections.forEach((section) => {
        if (!section.classList.contains('aseave-ritual--homepage')) {
          section.classList.add('aseave-ritual--homepage');

          // ページネーションドットが存在しない場合は追加
          if (!section.querySelector('.aseave-ritual__pagination')) {
            const scrollContainer = section.querySelector('.aseave-ritual__scroll-container');
            if (scrollContainer) {
              const pagination = document.createElement('ul');
              pagination.className = 'aseave-ritual__pagination';
              pagination.setAttribute('role', 'tablist');
              pagination.setAttribute('aria-label', '画像スライダーのページネーション');

              for (let i = 1; i <= 3; i++) {
                const li = document.createElement('li');
                li.setAttribute('role', 'presentation');

                const button = document.createElement('button');
                button.className = 'aseave-ritual__dot';
                if (i === 1) button.classList.add('is-active');
                button.setAttribute('role', 'tab');
                button.setAttribute('aria-label', `ステップ${i}へ移動`);
                button.setAttribute('aria-selected', i === 1 ? 'true' : 'false');

                li.appendChild(button);
                pagination.appendChild(li);
              }

              scrollContainer.parentNode.insertBefore(pagination, scrollContainer.nextSibling);
            }
          }
        }
      });
    }
  };

  const initRitualReveal = () => {
    const sections = document.querySelectorAll('.aseave-ritual');
    if (!sections.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach((section) => {
      section.classList.add('aseave-ritual--ready');

      if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
        section.classList.add('aseave-ritual--visible');
        return;
      }

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('aseave-ritual--visible');
              obs.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px 0px 0px'
        }
      );

      observer.observe(section);
    });
  };

  const initRitualPagination = () => {
    // モバイルのみ（768px以下）で実行
    if (window.innerWidth > 768) return;

    const sections = document.querySelectorAll('.aseave-ritual--homepage');
    if (!sections.length) return;

    sections.forEach((section) => {
      const scrollContainer = section.querySelector('.aseave-ritual__items');
      const pagination = section.querySelector('.aseave-ritual__pagination');
      const imageItems = section.querySelectorAll('.aseave-ritual__cell--image');

      if (!scrollContainer || !pagination || !imageItems.length) return;

      let isScrolling;
      let currentIndex = 0;

      // スクロール位置を更新してフェード効果を適用
      const updateScrollState = () => {
        const containerRect = scrollContainer.getBoundingClientRect();
        const containerCenter = containerRect.left + containerRect.width / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;

        imageItems.forEach((item, index) => {
          const itemRect = item.getBoundingClientRect();
          const itemCenter = itemRect.left + itemRect.width / 2;
          const distance = Math.abs(itemCenter - containerCenter);

          // 中央に最も近い画像を特定
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }

          // フェード効果を適用
          const distanceFromCenter = Math.abs(itemCenter - containerCenter);
          const threshold = containerRect.width / 6;

          if (distanceFromCenter > threshold) {
            item.classList.add('is-faded');
          } else {
            item.classList.remove('is-faded');
          }
        });

        // ページネーションドットを更新
        if (currentIndex !== closestIndex) {
          currentIndex = closestIndex;
          const dots = pagination.querySelectorAll('.aseave-ritual__dot');
          dots.forEach((dot, index) => {
            if (index === currentIndex) {
              dot.classList.add('is-active');
            } else {
              dot.classList.remove('is-active');
            }
          });
        }
      };

      // スクロールイベント
      scrollContainer.addEventListener('scroll', () => {
        clearTimeout(isScrolling);
        isScrolling = setTimeout(() => {
          updateScrollState();
        }, 50);
      }, { passive: true });

      // ドットクリックイベント
      const dots = pagination.querySelectorAll('.aseave-ritual__dot');
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const targetItem = imageItems[index];
          if (targetItem) {
            const containerRect = scrollContainer.getBoundingClientRect();
            const itemRect = targetItem.getBoundingClientRect();
            const scrollLeft = scrollContainer.scrollLeft;
            const offset = itemRect.left - containerRect.left;

            scrollContainer.scrollTo({
              left: scrollLeft + offset,
              behavior: 'smooth'
            });
          }
        });
      });

      // 初期状態を設定
      updateScrollState();
    });
  };

  const init = () => {
    checkViewParam();
    initRitualReveal();
    initRitualPagination();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
